import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import { DataCatalogDto, ResolvedFieldsDto } from './data-catalog.dto';

export const admiDataCatalogService = {
    getDataCatalog: async (): Promise<DataCatalogDto[]> => {
        const response = await httpClient2.get<DataCatalogDto[]>('/v1/documents/data-catalog');
        return response.data;
    },

    resolveFields: async (
        keys: string[],
        context: Record<string, unknown>,
        includeDependencyGraph: boolean,
    ): Promise<ResolvedFieldsDto> => {
        const response = await httpClient2.post<ResolvedFieldsDto>('/v1/documents/data-catalog/resolve', {
            keys,
            context,
            includeDependencyGraph,
        });
        return response.data;
    },
};
